import { PostData } from "../services/FetchData";

const AI_SYNONYMS_BASE = "api/v1/aisynonyms";

/**
 * Before/After ranking preview for a proposed synonym (Stage 8).
 */
export const previewSynonymBeforeAfter = ({ websiteId, searchTerm, synonyms }) =>
  PostData("ms1", `${AI_SYNONYMS_BASE}/before-after`, {
    websiteId,
    searchTerm,
    synonyms,
  });

/**
 * Protected regression gate check before synonym publish (Stage 8).
 */
export const runSynonymGateCheck = ({ websiteId, searchTerm, synonyms }) =>
  PostData("ms1", `${AI_SYNONYMS_BASE}/gate-check`, {
    websiteId,
    searchTerm,
    synonyms,
  });

/**
 * Approve or reject an AI suggested synonym.
 * @param {{ websiteId: string|number, synonymsId: string|number, searchTerm: string, synonyms: string[], action: 'approve'|'reject' }} params
 */
export const approveOrRejectSynonyms = ({
  websiteId,
  synonymsId,
  searchTerm,
  synonyms,
  action,
}) =>
  PostData("ms1", `${AI_SYNONYMS_BASE}/approveOrRejectSynonyms`, {
    websiteId,
    synonymsId,
    searchTerm,
    synonyms,
    action,
  });
